
import { defineComponent, ref, computed, getCurrentInstance } from "vue";
import { useStore } from 'vuex';
import defaultImage from "@/assets/images/user.png";
import ResponseData from "@/_models/ResponseData";
import { Profile, UpdateUser } from "@/_models/User";
import { createToast } from 'mosha-vue-toastify';
import 'mosha-vue-toastify/dist/style.css'
import XarcadeAccountService from "@/services/XarcadeAccountService";
import { UserUtils } from '@/utils/UserUtils';
import { countriesList } from "@/modules/countrylist";
import { Helper } from "@/utils/Helper";

export default defineComponent({
  name: "accountProfileComponent",
  setup(props, {emit}){
    const internalInstance = getCurrentInstance();
    const emitter = internalInstance.appContext.config.globalProperties.emitter;

    const store = useStore();
    let userObj = store.getters['auth/user'];
    const username = ref(userObj.username);


    const assetUrl = computed(() => {
      return store.getters['config/assetUrl'];
    });

    const image = ref(defaultImage);
    const strFirstName = ref('');
    const strLastName = ref('');
    const strUsername = ref('');
    const strEmail = ref('');
    const strGender = ref('');
    const strUserWebsite = ref('');
    const strUserCountry = ref('');
    const strUserDiscord = ref('');
    const strUserTwitter = ref('');
    const isSuccess = ref(false);
    const isFailure = ref(false);
    const alertMessage = ref('');
    const socialMedia = ref([]);
    const countryList = ref([]);

    const originalFirstName = ref('');
    const originalLastName = ref('');
    const originalGender = ref('');
    const originalCountry = ref('');
    const originalUserWebsite = ref('');
    const originalUserDiscord = ref('');
    const originalUserTwitter = ref('');


    (async() => {
      const fetchedProfile:Profile = await UserUtils.fetchProfile();
      originalFirstName.value = (!fetchedProfile.firstName? '': fetchedProfile.firstName);
      strFirstName.value = (!fetchedProfile.firstName? '': fetchedProfile.firstName);
      strLastName.value = (!fetchedProfile.lastName? '': fetchedProfile.lastName);
      originalLastName.value = (!fetchedProfile.lastName? '': fetchedProfile.lastName);
      strUsername.value = fetchedProfile.username;
      strEmail.value = fetchedProfile.email;
      strGender.value = fetchedProfile.gender;
      strUserCountry.value = fetchedProfile.country;
      originalGender.value = fetchedProfile.gender;
      originalCountry.value = fetchedProfile.country;
      strUserWebsite.value = fetchedProfile.websiteUrl;
      originalUserWebsite.value = fetchedProfile.websiteUrl;
      strUserTwitter.value = (!fetchedProfile.socialMedia? '':fetchedProfile.socialMedia["twitter"] );
      originalUserTwitter.value = (!fetchedProfile.socialMedia? '':fetchedProfile.socialMedia["twitter"] );
      strUserDiscord.value = (!fetchedProfile.socialMedia? '':fetchedProfile.socialMedia["discord"] );
      originalUserDiscord.value = (!fetchedProfile.socialMedia? '':fetchedProfile.socialMedia["discord"] );
      countryList.value.push(countriesList);
      if(fetchedProfile.profilePicture){
        image.value = assetUrl.value + 'blob/users/' + userObj.username + '/' + fetchedProfile.profilePicture;
      }
    })();

    const disabledSaveButton = computed(() => {
      return (strFirstName.value.length < 2 || strLastName.value.length < 2) ||  ((originalFirstName.value === strFirstName.value.trim()) && (originalLastName.value === strLastName.value.trim()) && (originalGender.value === strGender.value) && (originalCountry.value === strUserCountry.value) && (originalUserWebsite.value === strUserWebsite.value) && (originalUserTwitter.value === strUserTwitter.value) && (originalUserDiscord.value === strUserDiscord.value))
    });

    const updateUserDetails = async() => {
      isFailure.value = false;
      if(strFirstName.value.length == 0){
        isSuccess.value = false;
        isFailure.value = true;
        // alertMessage.value = 'Please insert First Name';
        createToast(
          {
            title: "Profile",
            description: 'Please insert First Name',
          },
          {
            position: "bottom-right",
            type: "danger",
          }
        );
      }
      if(strLastName.value.length == 0){
        isSuccess.value = false;
        isFailure.value = true;
        // alertMessage.value = ;
        createToast(
          {
            title: "Profile",
            description: 'Please insert Last Name',
          },
          {
            position: "bottom-right",
            type: "danger",
          }
        );
      }
      const urlPattern = new RegExp(/^(?:(?:https?|ftp):\/\/)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:\/\S*)?$/);
      if(strUserWebsite.value != null && strUserWebsite.value.length > 0){
        if(urlPattern.test(strUserWebsite.value) == false){
          isSuccess.value = false;
          isFailure.value = true;
          // alertMessage.value = ;
          createToast(
            {
              title: "Profile",
              description: 'Please insert the correct link format for your personal website',
            },
            {
              position: "bottom-right",
              type: "danger",
            }
          );
        }
      }
      if(strUserTwitter.value != null && strUserTwitter.value.length > 0){
        if(strUserTwitter.value == null){
          isSuccess.value = false;
          isFailure.value = true;
          // alertMessage.value = ;
          createToast(
            {
              title: "Profile",
              description: 'Please insert the correct Twitter username',
            },
            {
              position: "bottom-right",
              type: "danger",
            }
          );
        }
      }
      if(strUserDiscord.value != null && strUserDiscord.value.length > 0){
        if(strUserDiscord.value.length != 18 || (/\D/.test(strUserDiscord.value))){
          isSuccess.value = false;
          isFailure.value = true;
          // alertMessage.value = ;
          createToast(
            {
              title: "Profile",
              description: 'Please insert the correct 18-numerical Discord id',
            },
            {
              position: "bottom-right",
              type: "danger",
            }
          );
        }
      }
      if(!isFailure.value){
        const fetchedProfile:UpdateUser = await UserUtils.updateUserProfile(strFirstName.value, strLastName.value, strGender.value, strUserCountry.value, strUserWebsite.value, strUserTwitter.value, strUserDiscord.value);
        originalFirstName.value = strFirstName.value;
        originalLastName.value = strLastName.value;
        originalGender.value = strGender.value;
        originalCountry.value = strUserCountry.value;
        originalUserWebsite.value = strUserWebsite.value;
        originalUserTwitter.value = strUserTwitter.value;
        originalUserDiscord.value = strUserDiscord.value;
        // isSuccess.value = fetchedProfile.success ? true:false;
        // isFailure.value = !fetchedProfile.success ? true:false;
        // alertMessage.value = fetchedProfile.message;
        if(fetchedProfile.success){
          createToast(
            {
              title: "Profile updated",
              description: fetchedProfile.message,
            },
            {
              position: "bottom-right",
              type: "success",
            }
          );
        }
      }
    }

    // upload gamer profile photo
    const isDisplayUploadUserImageLabel = ref(false);
    const imageFile = ref("");
    const fileName = ref("");
    const previewImage = ref("");
    const fileInput = ref(null);
    const pickFile = () => {
      let input = fileInput.value;
      let file = input.files;
      fileName.value = file[0].name;
      imageFile.value = file;

      if (file[0]) {
        let reader = new FileReader();
        reader.onload = (e) => {
          image.value = e.target.result.toString();
        };
        reader.readAsDataURL(file[0]);
        emit("input", file[0]);
        // isDisplaySaveTokenImageOptions.value = true;
      }
    };

    const revertUserImage = () => {
      isDisplayUploadUserImageLabel.value = false;
      fileInput.value = null;
      previewImage.value = '';
    };

    const updateUserImage = () => {
      let formData = new FormData();

      if (imageFile.value !== "") {
        formData.append("ProfileStream", imageFile.value[0]);

        const jwtToken = store.getters['auth/jwtToken']

        XarcadeAccountService.updateUserDetails(userObj.userId, jwtToken, formData)
          .then((response: ResponseData) => {
            XarcadeAccountService.getXarcadeUser(userObj.userId)
              .then( async(getResponse: ResponseData) => {
                let fetchedUser = getResponse.data["xarcadeUser"];
                store.dispatch("auth/updateUser", {
                  userData: {...fetchedUser },
                });
                userObj = store.getters["auth/user"];
                emitter.emit('REFRESH_PROFILE_PHOTO', true);
              });
            Helper.toastSuccessHandling(response.data['message']);
            isDisplayUploadUserImageLabel.value = false;
          })
          .catch((error) => {
            Helper.endpointErrorHandling(error);
            console.log(error.response);
          });
      }
    };

    return {
      disabledSaveButton,
      username,
      countryList,
      strFirstName,
      strLastName,
      strUsername,
      strEmail,
      strGender,
      strUserWebsite,
      strUserCountry,
      strUserTwitter,
      strUserDiscord,
      updateUserDetails,
      isSuccess,
      isFailure,
      alertMessage,
      image,
      isDisplayUploadUserImageLabel,
      imageFile,
      fileName,
      previewImage,
      fileInput,
      pickFile,
      revertUserImage,
      updateUserImage,
    }
  }

});
